import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const LockScreen = ({ onUnlock }) => {
  const [swipeProgress, setSwipeProgress] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const prevHtml = document.documentElement.style.overflow;
    const prevBody = document.body.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    return () => {
      document.documentElement.style.overflow = prevHtml;
      document.body.style.overflow = prevBody;
    };
  }, []);

  const handleDragEnd = (event, info) => {
    setIsDragging(false);
    if (info.offset.y < -100) {
      setSwipeProgress(100);
      setTimeout(() => onUnlock(), 300);
    } else {
      setSwipeProgress(0);
    }
  };

  const handleDrag = (event, info) => {
    if (info.offset.y < 0) {
      const progress = Math.min(100, Math.abs(info.offset.y));
      setSwipeProgress(progress);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 bg-pure-black flex items-center justify-center overflow-hidden touch-none overscroll-none"
      style={{ height: '100svh' }}
    >
      {/* Glassmorphism overlay */}
      <div className="absolute inset-0 backdrop-blur-xl bg-black/50" />
      
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-screen w-full overflow-hidden">
        {/* NVS Branding */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="text-center mb-16"
        >
          <h1 className="text-7xl sm:text-9xl font-bold text-pure-white tracking-wider mb-2">
            NVSR
          </h1>
          <p className="text-pure-white/60 text-sm tracking-wide">
            (Website under development - some projects may not appear. Thank you for understanding)
          </p>
        </motion.div>

        {/* Swipe to unlock */}
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
          className="absolute bottom-12 sm:bottom-20 flex flex-col items-center"
        >
          <motion.div
            drag="y"
            dragConstraints={{ top: -200, bottom: 0 }}
            dragElastic={0.2}
            onDrag={handleDrag}
            onDragStart={() => setIsDragging(true)}
            onDragEnd={handleDragEnd}
            className="cursor-pointer"
          >
            <div className="flex flex-col items-center">
              <motion.div
                animate={{
                  y: isDragging ? 0 : [0, -10, 0],
                }}
                transition={{
                  duration: 2,
                  repeat: isDragging ? 0 : Infinity,
                  ease: "easeInOut",
                }}
                className="text-pure-white text-4xl mb-4"
              >
                ⌃
              </motion.div>
              <p className="text-pure-white text-lg tracking-wide">
                Swipe up to unlock
              </p>
            </div>
          </motion.div>

          {/* Progress indicator */}
          {swipeProgress > 0 && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="mt-4 w-48 h-1 bg-gray-700 rounded-full overflow-hidden"
            >
              <motion.div
                className="h-full bg-apple-blue"
                style={{ width: `${swipeProgress}%` }}
              />
            </motion.div>
          )}
        </motion.div>
      </div>
    </motion.div>
  );
};

export default LockScreen;
